// ─── Erreurs de champ (Core) ──────────────────────────────────────
// Principe app-wide : le ROUGE signale une INCOHÉRENCE entre valeurs saisies,
// jamais un champ pas-encore-rempli (un champ vide grise la disquette, sans
// rouge). Les champs fautifs reçoivent `styleChampErreur(UI)` (bordure + fond
// dangerTint) et une <LigneErreur> explique l'incohérence sous le champ ou la
// paire de champs. Le bandeau d'erreur de formulaire reste réservé aux erreurs
// serveur / d'enregistrement. Voir aussi PageHeader : action.enErreur affiche
// la pastille « ! » sur la disquette grisée (modifié mais pas enregistrable).
import React from 'react';
import { View, Text } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

// Fragment de style à poser sur n'importe quel champ (TextInput, bouton-date,
// bouton-heure…) : style={[s.input, enErreur && styleChampErreur(UI)]}
export const styleChampErreur = (UI) => ({
  borderColor: UI.danger, borderWidth: 1.5, backgroundColor: UI.dangerTint,
});

// Petite ligne rouge sous le(s) champ(s) fautif(s). `texte` déjà traduit.
export function LigneErreur({ texte, style }) {
  const UI = useUI();
  if (!texte) return null;
  return (
    <View style={[{ flexDirection: 'row', alignItems: 'flex-start', gap: 5, marginTop: 2, marginBottom: 6 }, style]}>
      <Text style={{ fontSize: 12 }}>⚠️</Text>
      <Text style={{ flex: 1, fontSize: 12.5, color: UI.danger, fontWeight: '600' }}>{texte}</Text>
    </View>
  );
}
